import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ChapterList from './chapter_list';

class View extends Component {
  async componentDidMount() {
    await this.props.getChapterList();
  }

  render() {
    const {
      chapterList,
    } = this.props;
    return (
      <main className="chapterlist">
        <ChapterList chapterList={chapterList} />
      </main>
    );
  }
}

View.propTypes = {
  getChapterList: PropTypes.func.isRequired,
  chapterList: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
